import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Text from 'Components/ComponentLibrary/Atoms/Text';

const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 20,
    alignItems: 'center',
  },
  logo: {
    width: 300,
    height: 'auto',
    objectFit: 'contain',
  },
});

const InstitutionHeader = ({
  className,
  classes,
  logo,
  name,
  balance,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {logo && <img className={classes.logo} src={logo} alt={`${logo}-logo`} />}
      {(!logo && name) && <Text variant={'h1'} weight={'bold'} value={name} />}
      {balance && <Text variant={'h1'} weight={'bold'} value={balance} test={'institution-accounts-balance'} />}
    </Box>
  );
};

InstitutionHeader.defaultProps = {
  className: '',
  logo: '',
  name: '',
  balance: '',
};

InstitutionHeader.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  logo: PropTypes.string,
  name: PropTypes.string,
  balance: PropTypes.string,
};

export default withStyles(styles)(InstitutionHeader);
